export class RfxTradingAccountsError extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'RfxTradingAccountsError';
  }
}
